import { Asker, Tasks } from 'common/src/utils/types';

export function cleanTaskData(task: Tasks): Omit<Tasks, 'User'> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { User, asker_payments, hasPayment, paymentStatus, asker, ...cleanedTask } =
    task as Tasks & {
      asker_payments?: unknown;
      hasPayment?: boolean;
      paymentStatus?: string;
      asker?: Asker
    };
  return cleanedTask;
}
